import { HowToWinBanner } from './HowToWinBanner';
import { setHowToWinBannerDismissedCookie } from '@/redux/modules/cookies';
import { useAppDispatch } from '@/redux/hooks';
import { useCallback } from 'react';
import { useHowToWinBannerDisplay } from './hooks/useHowToWinBannerDisplay';

type Props = {
    allowBigBanner?: boolean;
};

export const HowToWinBannerContainer = ({ allowBigBanner = false }: Props) => {
    const dispatch = useAppDispatch();
    const { shouldShow, showCloseButton, variant } = useHowToWinBannerDisplay(allowBigBanner);

    const onDismiss = useCallback(() => {
        dispatch(setHowToWinBannerDismissedCookie());
    }, [dispatch]);

    if (!shouldShow) {
        return null;
    }

    return (
        <HowToWinBanner
            onDismiss={onDismiss}
            showCloseButton={showCloseButton}
            variant={variant}
        />
    );
};
